import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_v_breadcrumbs, {
    breadcrumbs: $options.actualBreadcrumbs
  }, null, 8 /* PROPS */, ["breadcrumbs"]), _createElementVNode("div", null, [_renderSlot(_ctx.$slots, "default")])]);
}